import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import DualDrawCalculator from "../components/DualDrawCalculator";
import { ArrowRight, Calculator as CalcIcon } from "lucide-react";

const DualWeaponsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const fromEvent = location.state?.fromEvent;
  const eventName = location.state?.eventName;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  const handleBack = (e) => {
    if (fromEvent) {
      e.preventDefault();
      navigate(-1);
    }
  };

  return (
    <div
      className="App min-h-screen bg-[#0A1128] text-white"
      dir="rtl"
    >
      <div
        className="pointer-events-none fixed inset-0 opacity-[0.04] z-0"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />
      <div className="relative z-10">
        <Header />
        <div className="max-w-5xl mx-auto px-4 sm:px-6 pt-6">
          <Link
            to="/"
            onClick={handleBack}
            data-testid="dual-weapons-back-link"
            className="inline-flex items-center gap-1.5 text-slate-300 hover:text-[#E5CB94] text-sm transition-colors"
          >
            <ArrowRight className="w-4 h-4" />
            <span>{fromEvent ? "الرجوع لبطاقة العجلة" : "الرجوع للرئيسية"}</span>
          </Link>
          {eventName && (
            <div className="mt-3 inline-flex items-center gap-2 rounded-lg bg-[#C9A96A]/[0.06] border border-[#C9A96A]/25 text-[#E5CB94] text-[11px] font-bold px-2.5 py-1">
              العجلة المختارة: {eventName}
            </div>
          )}
        </div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 pt-6 text-center">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#C9A96A]/[0.06] border border-[#C9A96A]/20 text-[#D4B98A] text-[11px] font-medium mb-3">
            <CalcIcon className="w-3 h-3" />
            <span>العجلة المزدوجة</span>
          </div>
          <h1
            className="font-black leading-tight text-[1.75rem] sm:text-[2.5rem]"
            style={{ fontFamily: "'Alexandria', 'Tajawal', sans-serif" }}
          >
            <span className="block text-[#F5F1E8]">حاسبة العجلة المزدوجة</span>
            <span
              className="block mt-1 bg-clip-text text-transparent"
              style={{
                backgroundImage:
                  "linear-gradient(100deg, #B08A4A 0%, #E5CB94 45%, #D4B278 60%, #B08A4A 100%)",
              }}
            >
              الأسلحة الأسطورية
            </span>
          </h1>
        </div>
        <DualDrawCalculator
          type="weapons"
          title="العجلة المزدوجة — الأسلحة الأسطورية"
          subtitle="10 سحبات • 11 من أصل 20 عنصراً"
        />
        <Footer />
      </div>
    </div>
  );
};

export default DualWeaponsPage;
